import React, { useEffect, useState } from "react";
import Styles from "./styles.module.css";

type SlidingChipSelectorProps = {
  initialIndex?: number;
  onSelected: (index: number) => void;
};

export const SlidingChipSelector: React.FC<SlidingChipSelectorProps> = ({
  initialIndex = 0,
  onSelected,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);

  useEffect(() => {
    setSelectedIndex(initialIndex);
  }, [initialIndex]);

  const chipWidth = 96;
  const chipHeight = 34;
  const padding = 2;

  return (
    <div className={Styles.chip_box}>
      <div
        style={{
          position: "relative",
          width: chipWidth * 2 + padding * 2,
          height: chipHeight,
        }}
      >
        {/* スライド背景 */}
        <div className={Styles.chip_background}
          style={{
            left: selectedIndex === 0 ? 0 : chipWidth + padding,
            width: chipWidth,
            height: chipHeight,
            borderRadius: chipHeight / 2,
            transition: "left 250ms ease-in-out",
          }}
        />

        {/* チップ */}
        <div className={Styles.chip}>
          <Chip
            label="事業者様"
            active={selectedIndex === 0}
            width={chipWidth}
            height={chipHeight}
            onClick={() => {
              setSelectedIndex(0);
              onSelected(0);
            }}
          />

          <div style={{ width: padding }} />

          <Chip
            label="学校関係者様"
            active={selectedIndex === 1}
            width={chipWidth}
            height={chipHeight}
            onClick={() => {
              setSelectedIndex(1);
              onSelected(1);
            }}
          />
        </div>
      </div>
    </div>
  );
};

type ChipProps = {
  label: string;
  active: boolean;
  width: number;
  height: number;
  onClick: () => void;
};

const Chip: React.FC<ChipProps> = ({
  label,
  active,
  width,
  height,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        width,
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: 12,
        fontWeight: "bold",
        color: active ? "#FFFFFF" : "#1B1B1B",
        userSelect: "none",
      }}
    >
      {label}
    </div>
  );
};
